import { SIFPortfolioData, SIFSchemesWithReturns } from "@/type/sifPageTypes";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SIFDetailsModalState {
  isOpen: boolean;
  funds?: SIFSchemesWithReturns | null;
  portfolioData?: SIFPortfolioData | null;
}

const initialState: SIFDetailsModalState = {
  isOpen: false,
  funds: null,
  portfolioData: null,
};

const sifDetailsModalSlice = createSlice({
  name: "sifDetailsModal",
  initialState,
  reducers: {
    openSIFDetailsModal: (state) => {
      state.isOpen = true;
    },
    closeSIFDetailsModal: (state) => {
      state.isOpen = false;
    },
    setSIFDetailsModal: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
    setSIFDetailsModalFunds: (state, action: PayloadAction<SIFSchemesWithReturns | null>) => {
      state.funds = action.payload;
    },
    setSIFDetailsModalPortfolioData: (state, action: PayloadAction<SIFPortfolioData | null>) => {
      state.portfolioData = action.payload;
    },
  },
});

export const {
  openSIFDetailsModal,
  closeSIFDetailsModal,
  setSIFDetailsModal,
  setSIFDetailsModalFunds,
  setSIFDetailsModalPortfolioData,
} = sifDetailsModalSlice.actions;
export default sifDetailsModalSlice.reducer;
